import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'GCADA-lazy-loading',
    templateUrl: './lazy-loading.component.html',
    styleUrls: ['./lazy-loading.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class GCADALazyLoadingComponent implements OnInit {

    /**
     * Constructor
     */
    constructor() { }
    

    ngOnInit(): void {

    }
}